import React, { useEffect, useState } from 'react'
import './tabsmenu.less'
import { ButtonTabsComponent as ButtonTab } from '../../components'
import { Link } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { buttonsApprovals, buttonsClient, buttonsWallet, buttonsSaques } from './menus'
import { checkAccess } from '../../services/accessControl'
import { useSelector } from 'react-redux'

const TabsMenuComponent = (props) => {
    const { type } = props

    const { isLoadingNotifications, notifications } = useSelector(state => state.monitors)

    const returnNotifications = (type) => {
        if(type === 'aportes') {
            return parseInt(notifications.aportes || 0)
        } else if(type === 'resgates') {
            return parseInt(notifications.resgates || 0)
        } else if(type === 'asa') {
            return parseInt(notifications.asa || 0)
        } else if(type === 'spirit') {
            return parseInt(notifications.spirit || 0)
        } else if(type === 'spirit2') {
            return parseInt(notifications.spirit2 || 0)
        } else if(type === 'spirit3') {
            return parseInt(notifications.spirit3 || 0)
        } else if(type === 'bats') {
            return parseInt(notifications.bats || 0)
        } else if(type === 'conversoes' || type === 'geral') {
            return undefined
        } else if(type === 'tokens') {
            return parseInt(notifications.tokens || 0)
        } else if(type === 'pendentes') {
            if (props.type === 'saques') {
                return parseInt(notifications.saques || 0)
            } else {
                return parseInt(notifications.clientes || 0) 
            }
        } else if(type === 'historico') {
            return undefined
        } else {
            return 0
        }
    }
    
    const components = {
        clients: buttonsClient,
        approvals: buttonsApprovals,
        wallet: buttonsWallet,
        saques: buttonsSaques
    }
    
    const location = useLocation()
    const path = location.pathname
    const [allowed, setAllowed] = useState([])

    useEffect(() => {
        let mounted = true
        const load = async () => {
            const cfg = components[type] || []
            const checks = await Promise.all(cfg.map((i) => checkAccess(undefined, i.link)))
            if (!mounted) return
            setAllowed(cfg.filter((_, idx) => checks[idx] !== false))
        }
        load()
        return () => { mounted = false }
    }, [type])

    return (
        <div className="tabs-menu-wrapper">
            {(allowed.length ? allowed : components[type]).map((i, p) => (
                <Link to={i.link} key={i.title + p}><ButtonTab type="tabs" text={i.title} notification={isLoadingNotifications ? undefined : returnNotifications(i.key)} active={path === i.link} /></Link>
            ))}
        </div>
    )
}

export default TabsMenuComponent